import React from "react";
import { Provider } from "react-redux";
import { store } from "../components/checkout/store";
import AddToCart from "../components/checkout/components/AddToCart/AddToCart";
import { createRoot } from "react-dom/client";
import PropTypes from "prop-types";

/**
 * Add to cart button
 *
 * @param productId
 * @returns {Element}
 * @constructor
 */
const CartButton = ({ productId }) => {
  return (
    <Provider store={store}>
      <AddToCart productId={productId} />
    </Provider>
  );
};

CartButton.propTypes = {
  productId: PropTypes.string.isRequired,
};

export const mountAddToCartButton = () => {
  const domNodesAddToCart = document.getElementsByClassName("add-to-cart-container");
  Array.from(domNodesAddToCart).forEach(domNode => {
    // Check if this node has already been initialized with React
    if (!domNode.hasAttribute("data-react-initialized")) {
      const productId = domNode.getAttribute("data-product-id");
      const rootAddToCart = createRoot(domNode);
      rootAddToCart.render(<CartButton productId={productId} />);

      // Mark this node as initialized
      domNode.setAttribute("data-react-initialized", "true");
    }
  });
};

mountAddToCartButton();
